import { ListItemButton, ListItemButtonProps, ListItemIcon, ListItemText } from '@mui/material';
import { generateEnvUrl } from '@utils/env';
import { sxStyles } from './AppMenuListItem.styles';

export interface NavConfig {
  disabled?: boolean;
  icon: React.ReactElement;
  key?: string;
  orgAccess?: string[];
  path: string;
  title: string;
  translateKey: string;
}

export interface AppMenuListItemProps extends ListItemButtonProps {
  item: NavConfig;
}

export const AppMenuListItem: React.FC<AppMenuListItemProps> = ({ item, sx, ...rest }) => {
  return (
    <ListItemButton
      component="a"
      href={generateEnvUrl(item.path ?? '')}
      sx={{ ...sxStyles.listItemButton, ...sx }}
      {...(item.path === 'https://secure.seamlesswbl.com/index.php/' ? { target: '_blank' } : {})}
      {...rest}
    >
      <ListItemIcon sx={sxStyles.listItemIcon}>{item.icon}</ListItemIcon>
      <ListItemText>{item.title}</ListItemText>
    </ListItemButton>
  );
};
